import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit, Close as IconClose } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import { API_CONFIG, CONFIG, NOTIFY } from "common/config";
import { LABELS, WARNINGS, TITLES, SUB_TITLES } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";

import { MASTER_APIs } from "apihandlers/master";
import { REPORTS_APIs } from "apihandlers/reports";
import { COLORS } from "common/colors";
import UiDialog from "components/Custom/UiDialog";
import TxtRow from "components/Custom/TxtRow";
import RadioBtn from "components/Custom/RadioBtn";
import SkeletonBox from "components/Custom/SkeletonBox";
import { AUTH_APIs } from "apihandlers/auth";

const thumbnailImg = require("assets/images/pdf.png");

const UploadTDSPayment = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [dialogue, setDialogue] = useState(false);
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>([{}]);
  const [selectedRow, setSelectedRow] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [tdsFiles, setTdsFiles] = useState<any>([]);
  const [uploading, setUploading] = useState<boolean>(false);
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "month",
      name: LABELS.MONTH,
      width: "20%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "year",
      name: LABELS.YEAR,
      width: "20%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "tdsAmount",
      name: LABELS.TDS_AMOUNT,
      width: "20%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "uploadedFile",
      name: LABELS.UPLOADED_FILE,
      width: "30%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];
  const outletRef: any = useRef();
  const monthRef: any = useRef();

  const monthsList = [
    { id: "jan", label: "JAN" },
    { id: "feb", label: "FEB" },
    { id: "mar", label: "MAR" },
    { id: "apr", label: "APR" },
    { id: "may", label: "MAY" },
    { id: "jun", label: "JUN" },
    { id: "jul", label: "JUL" },
    { id: "aug", label: "AUG" },
    { id: "sep", label: "SEP" },
    { id: "oct", label: "OCT" },
    { id: "nov", label: "NOV" },
    { id: "dec", label: "DEC" },
  ];

  useEffect(() => {
    if (loading) {
      getOrgProfile();
    }
  }, [loading]);

  const getOrgProfile = () => {
    const args = {
      minResponse: true,
    };
    MASTER_APIs.getOrgProfiles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].id,
            label: recs[i].organizationName,
          });
        }
        setMasters(list);
        // setLoading(false);
      }
    });
  };

  // const loadData = () => {
  //   const outlet = outletRef.current.selectedValue.id;
  //   const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
  //     .value;
  //   const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
  //   const args = {
  //     fromDt,
  //     toDt,
  //     outlet,
  //     reportType: "excel",
  //   };
  //   let errors = [];
  //   if (!outlet) {
  //     errors.push({
  //       id: "outlet",
  //       msg:
  //         "<span class='bold'>" +
  //         LABELS.OUTLET +
  //         "</span> " +
  //         WARNINGS.IS_A_REQUIRED_FIELD,
  //     });
  //   }
  //   if (fromDt === "") {
  //     errors.push({
  //       id: "fromDt",
  //       msg:
  //         "<span class='bold'>" +
  //         LABELS.FROM_DATE +
  //         "</span> " +
  //         WARNINGS.IS_A_REQUIRED_FIELD,
  //     });
  //   }
  //   if (toDt === "") {
  //     errors.push({
  //       id: "toDt",
  //       msg:
  //         "<span class='bold'>" +
  //         LABELS.TO_DATE +
  //         "</span> " +
  //         WARNINGS.IS_A_REQUIRED_FIELD,
  //     });
  //   }
  //   setMandatoryResults(errors);
  //   if (errors.length > 0) {
  //     COMMON_JS.showNotify(
  //       props,
  //       NOTIFY.WARNING,
  //       WARNINGS.PLEASE_CHECK_FORM_ERRORS
  //     );
  //     return;
  //   }

  //   setRows(null);
  //   // setLoading(true);
  //   REPORTS_APIs.getDmsSalesReturn(args).then((res) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       for (let i = 0; i < response.rows.length; i++) {
  //         response.rows[i]["slNo"] = i + 1;
  //       }
  //       setRows(response.rows);
  //       setLoading(false);
  //     }
  //   });
  // };

  const reloadGrid = () => {
    setRows(null);
    // loadData();
  };
  const addData = () => {
    setDialogue(true);
  };
  const onEditRow = (row: any) => {
    // setSelectedRow(row);
    setDialogue(true);
    // console.log(selectedRow);
  };

  const onUploadFile = (e: any, f: any) => {
    console.log("onUploadFile: ", e, f);
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      setUploading(true);
      uploadFile(file, base64).then((res) => {
        setUploading(false);
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "payment",
    };
    let fileInfo = null;
    try {
      const res = await AUTH_APIs.fileUpload(args);
      console.log("uploadFile: ", args, res);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        setTdsFiles([...tdsFiles, fileInfo]);
        (document.getElementById("uploadFile") as HTMLInputElement).value =
          null;
      }
    } catch (error) {}
    return fileInfo;
  };

  const onManage = () => {
    const month = monthRef.current.selectedValue.id;
    const year = document.querySelector(
      'input[name="Year"]:checked'
    ) as HTMLInputElement;
    const status = year ? year.value : "";
    const tdsAmount = (document.getElementById("amount") as HTMLInputElement)
      .value;

    const args = { month, status, tdsAmount, tdsFiles };
    console.log("args", args);
    setDialogue(false);
    setMandatoryResults([]);
  };

  console.log("Page: Upload TDS payment:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.ACCOUNT}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.UPLOAD_TDS_PAYMENT}</li>
        </ul>
        <h4>{TITLES.UPLOAD_TDS_PAYMENT}</h4>
        <p>{SUB_TITLES.UPLOAD_TDS_PAYMENT}</p>
      </div>
      <div>
        {mandatoryResults.length > 0 && (
          <div className="mandatoryBox">
            <ul>
              {mandatoryResults.map((m) => {
                return (
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        <div className="grid excelGridWrapper">
          {loading &&
            (rows ? (
              <ExcelGrid
                id={"uploadTDSPayment"}
                height={window.innerHeight * 0.8}
                cols={columns}
                rows={rows}
                exportOption={true}
                newRowOption={false}
                exportName={LABELS.SALES_RETURN_REPORT}
                hideUnhide={true}
                onReload={reloadGrid}
                onAdd={addData}
              />
            ) : (
              <div className="flexCenter" style={{ minHeight: 450 }}>
                <Loader />
              </div>
            ))}
        </div>
        {dialogue && (
          <UiDialog
            title={"Upload TDS Payment"}
            open={true}
            size={"sm"}
            onClose={() => {
              setDialogue(false);
              setMandatoryResults([]);
            }}
          >
            <div className="formGroup red">
              <label>
                {LABELS.MONTH}
                {<span className="red">*</span>}
              </label>
              <AutoComplete
                list={monthsList}
                childRef={monthRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.countryId,
                        label: selectedRow.countryName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                // disabled={isSubmit}
              />
            </div>
            <div>
              <label>Year</label>
              <RadioBtn
                list={[
                  {
                    id: "2023",
                    value: "2023",
                    label: "2023",
                    checked: true,
                    disabled: false,
                  },
                  {
                    id: "2024",
                    value: "2024",
                    label: "2024",
                    disabled: false,
                  },
                ]}
                row={true}
                name={"Year"}
              />
            </div>
            <div className="formGroup red">
              <TxtRow
                id={"amount"}
                type={"text"}
                label={LABELS.TDS_AMOUNT}
                required={true}
                //   defaultValue={selectedRow.code}
                //   disabled={isSubmit}
              />
            </div>

            <label>
              {LABELS.UPLOAD_FILE}
              <small>
                {" ( Max File Size: " + CONFIG.MAX_FILE_SIZE + " MB )"}
              </small>
            </label>
            <div>
              <TxtBox
                type={"file"}
                id="uploadFile"
                defaultValue={selectedRow.id ? selectedRow.tdsFiles : null}
                // className="uploadFile"
                accept="image/*"
                onChange={onUploadFile}
              />
            </div>

            <div
              className="formGroup"
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
              }}
            >
              {tdsFiles.map((u, i) => {
                return (
                  <div className="thumbnailBox width20">
                    <IconButton
                      className="thumbnailBoxIcon"
                      onClick={() => {
                        const list = tdsFiles.filter((a, j) => j !== i);
                        setTdsFiles(list);
                      }}
                    >
                      <IconClose />
                    </IconButton>
                    <img
                      onClick={() =>
                        window.open(API_CONFIG.STATIC_URL + u.path, "_blank")
                      }
                      src={
                        u.mimeType === "pdf"
                          ? thumbnailImg
                          : API_CONFIG.STATIC_URL + u.path
                      }
                      className="responsive cursor"
                    />
                  </div>
                );
              })}
              <div style={{ marginTop: "10px" }}>
                <Btn
                  text={LABELS.SAVE}
                  //loading={isSubmit}
                  onClick={onManage}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>

              {uploading && (
                <div className="thumbnailBox width20">
                  <SkeletonBox height={300} />
                </div>
              )}
            </div>
          </UiDialog>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(UploadTDSPayment);
